module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-07-803c416bccd9ceb10dc0291dcede0af0.svg";